import getFilterableMailListContextMenuItems from './getFilterableMailListContextMenuItems';
import { observer } from 'mobx-react';
import { IPoint } from 'office-ui-fabric-react/lib/Utilities';
import * as React from 'react';
import {
    ContextualMenu,
    DirectionalHint,
} from 'office-ui-fabric-react/lib/components/ContextualMenu';
import MailListContextMenuSource from 'owa-mail-list-store/lib/store/schema/MailListContextMenuSource';
import getMailListItemPartContextMenuItems from './getMailListItemPartContextMenuItems';
import { getMoveToPropertiesForContextMenu } from 'owa-mail-movetofolder-view/lib/components/getMoveToMenuProperties';
import { getMailMenuItemShouldShowMap } from 'owa-mail-filterable-menu-behavior';
import { listViewStore } from 'owa-mail-list-store';
import MailListContextMenuType from 'owa-mail-list-store/lib/store/schema/MailListContextMenuType';
import { getCategoryMenuPropertiesForContextMenu } from 'owa-mail-category-view';
export interface MailListItemContextMenuProps {
    anchorPoint: IPoint;
    menuType: MailListContextMenuType;
    menuSource?: MailListContextMenuSource;
    tableViewId: string;
    onDismiss: (ev?: any) => void;
}

@observer
export default class MailListItemContextMenu extends React.Component<
    MailListItemContextMenuProps,
    {}
> {
    render() {
        const { anchorPoint, menuType, menuSource } = this.props;
        let menuProps = null;
        const tableView = listViewStore.tableViews.get(this.props.tableViewId);
        const tableViewId = this.props.tableViewId;
        const onDismiss = this.props.onDismiss;

        if (menuType === MailListContextMenuType.All) {
            const defaultProps = {
                shouldFocusOnMount: true,
                target: anchorPoint,
                directionalHint: DirectionalHint.bottomLeftEdge,
                onDismiss: this.props.onDismiss,
                calloutProps: { preventDismissOnScroll: true }, // Prevent setting scrolltop from reading pane to dismiss the right click context menu
            };
            if (menuSource == MailListContextMenuSource.MailListItem) {
                const selectedRowKeys = [...tableView.selectedRowKeys.keys()];
                menuProps = {
                    ...defaultProps,
                    items: getFilterableMailListContextMenuItems(
                        selectedRowKeys,
                        tableViewId,
                        onDismiss
                    ).filter(item => item.shouldShow()),
                };
            } else {
                menuProps = {
                    ...defaultProps,
                    items: getMailListItemPartContextMenuItems(
                        listViewStore.expandedConversationViewState.selectedNodeIds,
                        tableViewId,
                        onDismiss
                    ),
                };
            }
        } else {
            const defaultProps = {
                shouldFocusOnMount: true,
                target: anchorPoint,
                onDismiss: this.props.onDismiss,
            };
            if (menuType === MailListContextMenuType.MoveTo) {
                const shouldShowBehaviorMap = getMailMenuItemShouldShowMap();
                menuProps = {
                    ...defaultProps,
                    ...getMoveToPropertiesForContextMenu(
                        tableViewId,
                        onDismiss,
                        'Keyboard',
                        shouldShowBehaviorMap,
                        null,
                        true
                    ),
                };
            } else if (menuType === MailListContextMenuType.Categorize) {
                menuProps = {
                    ...defaultProps,
                    ...getCategoryMenuPropertiesForContextMenu(
                        tableViewId,
                        onDismiss,
                        'Keyboard',
                        true
                    ),
                };
            }
            menuProps.directionalHintFixed = false;
        }

        return <ContextualMenu {...menuProps} />;
    }
}
